import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dIndex from "../Foreign.Index/index.js";
const $RPCError = (tag, _1, _2) => ({tag, _1, _2});
const bind = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const ix = /* #__PURE__ */ (() => Foreign$dIndex.indexString(Data$dIdentity.monadIdentity).index)();
const readInt = /* #__PURE__ */ Foreign.readInt(Data$dIdentity.monadIdentity);
const readString = /* #__PURE__ */ Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String");
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const MethodNotFound = value0 => $RPCError("MethodNotFound", value0);
const InvalidParams = value0 => $RPCError("InvalidParams", value0);
const OtherError = value0 => value1 => $RPCError("OtherError", value0, value1);
const showRpcError = {
  show: v => {
    if (v.tag === "MethodNotFound") { return "RPC Error: method not found. " + v._1; }
    if (v.tag === "InvalidParams") { return "RPC Error: invalid params sent to the server. " + v._1; }
    if (v.tag === "OtherError") { return "RPC Error " + Data$dShow.showIntImpl(v._1) + ": " + v._2; }
    $runtime.fail();
  }
};
const eqRPCError = {
  eq: x => y => {
    if (x.tag === "MethodNotFound") {
      if (y.tag === "MethodNotFound") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "InvalidParams") {
      if (y.tag === "InvalidParams") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "OtherError") {
      if (y.tag === "OtherError") { return x._1 === y._1 && x._2 === y._2; }
      return false;
    }
    return false;
  }
};
const decodeRPCError = {
  decode: value => bind(bind(ix(value)("code"))(readInt))(code => bind(bind(ix(value)("message"))(readString))(message => pure((() => {
    if (code === -32601) { return $RPCError("MethodNotFound", message); }
    if (code === -32602) { return $RPCError("InvalidParams", message); }
    return $RPCError("OtherError", code, message);
  })())))
};
export {$RPCError, InvalidParams, MethodNotFound, OtherError, bind, decodeRPCError, eqRPCError, ix, pure, readInt, readString, showRpcError};
